import { render } from "./AiChat.vue?vue&type=template&id=c3422522&ts=true"
import script from "./AiChat.vue?vue&type=script&lang=ts"
export * from "./AiChat.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__